import axios from "axios";
import headerRequest from "../config/headers";

const API_URL = process.env.REACT_APP_API_URL_SST;
const prefix = 'user';
const url = window.location.pathname;
const commonParams = { url: url };

class UserService {
    async showAll() {
        const ruta = `${API_URL}/${prefix}`;
        const params = { ...commonParams };
        const headers = await headerRequest();
        return axios.get(ruta, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async showPlantsByUser(id_usuario) {
        const ruta = `${API_URL}/${prefix}/plants/${id_usuario}`;
        const params = { ...commonParams };
        const headers = await headerRequest();
        return axios.get(ruta, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async saveUserPlants(body) {
        const ruta = `${API_URL}/${prefix}/plants`;
        const params = { ...commonParams };
        const headers = await headerRequest();
        return axios.post(ruta, body, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async showGroupingUser(queryParameters) {
        const ruta = `${API_URL}/${prefix}/grouping`;
        const headers = await headerRequest();
        const params = { ...commonParams, ...queryParameters };
        return axios.get(ruta, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

    async saveOrUpdate(body) {
        const ruta = `${API_URL}/${prefix}`;
        const headers = await headerRequest();
        const params = { ...commonParams };
        return axios.post(ruta, body, {
            headers: headers,
            params: params,
        }).catch((error) => {
            return error;
        });
    }

}

export default new UserService();